import { Link } from "react-router-dom";
import { Cross, Heart, Sparkles } from "lucide-react";
import Seo from "@/components/Seo";

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <Seo
        title="About · Jesus Just Us"
        description="Jesus Just Us is a Kingdom community platform — a quiet, reverent place where believers gather, pray, share, and serve. One faith. One family. One mission."
        path="/about"
      />
      <div className="overline text-burgundy">About Jesus Just Us</div>
      <h1 className="font-serif text-5xl text-jjblue mt-3">One Faith. One Family. One Mission.</h1>
      <p className="mt-6 text-lg text-[var(--jj-text-secondary)] leading-relaxed">
        Jesus Just Us (JJU) is a Kingdom community platform — a quiet, reverent
        place where believers gather, pray, share, and serve. It's not a feed. It's a family.
      </p>

      <div className="grid sm:grid-cols-3 gap-5 mt-10">
        <div className="jj-card p-6">
          <Cross className="h-6 w-6 text-burgundy" strokeWidth={1.5} />
          <h3 className="font-serif text-2xl mt-4 text-jjblue">Our Mission</h3>
          <p className="mt-3 text-sm text-[var(--jj-text-secondary)] leading-relaxed">
            To unite the body of Christ in a digital space rooted in prayer, truth, and tangible service —
            a refuge where every believer can belong and be built up.
          </p>
        </div>
        <div className="jj-card p-6">
          <Sparkles className="h-6 w-6 text-burgundy" strokeWidth={1.5} />
          <h3 className="font-serif text-2xl mt-4 text-jjblue">Our Vision</h3>
          <p className="mt-3 text-sm text-[var(--jj-text-secondary)] leading-relaxed">
            A national Kingdom directory connecting churches, ministries, businesses, and
            believers — making it easy to find help, give help, and lift one another up.
          </p>
        </div>
        <div className="jj-card p-6">
          <Heart className="h-6 w-6 text-burgundy" strokeWidth={1.5} />
          <h3 className="font-serif text-2xl mt-4 text-jjblue">Our Promise</h3>
          <p className="mt-3 text-sm text-[var(--jj-text-secondary)] leading-relaxed">
            No ads. No noise. No exploitation. Just His people, gathered — moderated by
            members who love Jesus and care for the family.
          </p>
        </div>
      </div>

      <div className="mt-14 jj-card p-8">
        <div className="overline text-burgundy">Why we exist</div>
        <h2 className="font-serif text-3xl text-jjblue mt-2">A different kind of social</h2>
        <p className="mt-4 text-[var(--jj-text-secondary)] leading-relaxed">
          Mainstream social media monetizes outrage. We don't. Jesus Just Us is built to make it easy
          to share testimonies, lift prayer requests, find a church, support faith-led businesses, and
          serve the elders, the orphans, and the overlooked. Every feature exists to encourage believers
          and strengthen the Kingdom.
        </p>
        <p className="mt-4 text-[var(--jj-text-secondary)] leading-relaxed">
          Whether you're an individual seeking community, a church wanting to reach further, a nonprofit
          serving the broken, or a business honoring the Lord in your work — there's a place for you here.
        </p>
      </div>

      <div className="mt-10 text-center">
        <Link to="/register" className="btn-primary" data-testid="about-join">Join the community</Link>
      </div>
    </div>
  );
}
